export const URLS  = {
    URL_LOGIN  : String(window._env_.REACT_APP_URL_LOGIN),
    BASE_URL : String(window._env_.REACT_APP_FRONT_URL),
    URL_ENDPOINT: String(window._env_.REACT_APP_URL_ENDPOINT),
    URL_TOTAL_REWARDS_STATEMENT: String(window._env_.REACT_APP_URL_TOTAL_REWARDS_STATEMENT),
    URL_TOTAL_REWARDS_SHAREPOINT: String(window._env_.REACT_APP_URL_TOTAL_REWARDS_SHAREPOINT),
    TAG_GOOGLE : String(window._env_.REACT_APP_TOKEN_GOOGLE),
    URL_LOGOUT: String(window._env_.REACT_APP_URL_LOGOUT),
}
